import React, {useState, forwardRef, useImperativeHandle, useEffect} from 'react';

import './styles.scss';
import chevron_up from '../../../icons/chevron-up2.svg';
import chevron_down from '../../../icons/chevron-down2.svg';
import CurrentLocation from '../CurrentLocation/CurrentLocation';
import TypeaheadSearch from '../TypeaheadSearch/TypeaheadSearch';
import {LocationFilterProps, LocationFilterRef } from './props';
import RadiusDropdown from "../RadiusDropdown/RadiusDropdown";

const LocationFilter = forwardRef<LocationFilterRef, LocationFilterProps>((props, ref) => {
  const {searchOptions, radiusDefaultText} = props;
  const [isOpen, setIsOpen] = useState(props.isOpen ?? true);
  const [typeSearchValue, setTypeSearchValue] = useState(props.defaultSearch || '');
  const [radiusValue, setRadiusValue] = useState(radiusDefaultText);
  const [typeAheadOptions, setTypeAheadOptions] = useState(searchOptions);
  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  useEffect(() => {
    setTypeAheadOptions(searchOptions);
  }, [searchOptions]);

  const onChangeRadius = (index: number, value?: string) => {
    const newRadiusValue = props.radiusOptions[index];
    setRadiusValue(newRadiusValue);
    props.onChangeRadius?.(index, value);
  }

  useImperativeHandle(ref, () => ({
    setTypeaheadSearch: (value: string) => {
      setTypeSearchValue(value);
    },
    setRadius: (value: string) => {
      setRadiusValue(value);
    },
    getRadius: () => {
      return radiusValue;
    },
    getTypeaheadSearch: () => {
      return typeSearchValue;
    },
  }));
  return (
    <div className={`location-filter ${props.isMobile ? 'mobile-filter' : ''}`}>
      <div className='location-filter__heading' onClick={toggleAccordion}>
        <h4>{props.heading}</h4>
        <img src={isOpen ? chevron_up : chevron_down} alt='location filter toggle icon' />
      </div>
      {isOpen && (
        <div className='location-filter__content'>
          <div className='location-filter__search-wrapper'>
          <TypeaheadSearch
            placeholder={props.searchPlaceholder}
            options={typeAheadOptions}
            notFoundText={props.searchNotFoundText}
            search={typeSearchValue}
            onSearchChange={props.onLocationChange}
            minCharacters={props.minCharacters}
          />
          <CurrentLocation currentLocationText={props.currentLocationText} locationDeniedAlertText={props.locationDeniedAlertText} onLocationChange={props.onLocationChange} errorText={props.locationErrorText}/>
          </div>
          <RadiusDropdown
            options={props.radiusOptions}
            label={props.radiusLabel}
            defaultText={radiusValue}
            onChangeRadius={onChangeRadius}
          />
        </div>
      )}
    </div>
  );
});
LocationFilter.displayName = 'LocationFilter';

export default React.memo(LocationFilter);
